"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDataSubCategoryType = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
const connection_1 = require("./connection");
const contact_1 = require("./contact");
const demographic_1 = require("./demographic");
const device_1 = require("./device");
const financial_1 = require("./financial");
const health_1 = require("./health");
const id_1 = require("./id");
const location_1 = require("./location");
const onlineActivity_1 = require("./onlineActivity");
const socialMedia_1 = require("./socialMedia");
const survey_1 = require("./survey");
const tracking_1 = require("./tracking");
const userProfile_1 = require("./userProfile");
const notPersonalData_1 = require("./notPersonalData");
exports.DefaultDataSubCategoryType = (0, type_utils_1.makeEnum)({
    ...connection_1.ConnectionSubCategory,
    ...contact_1.ContactSubCategory,
    ...demographic_1.DemographicSubCategory,
    ...device_1.DeviceSubCategory,
    ...financial_1.FinancialSubCategory,
    ...health_1.HealthSubCategory,
    ...id_1.IdSubCategory,
    ...location_1.LocationSubCategory,
    ...onlineActivity_1.OnlineActivitySubCategory,
    ...socialMedia_1.SocialMediaSubCategory,
    ...survey_1.SurveySubCategory,
    ...tracking_1.TrackingSubCategory,
    ...userProfile_1.UserProfileSubCategory,
    ...notPersonalData_1.NotPersonalDataSubCategory,
});
//# sourceMappingURL=index.js.map